import { createRouter, createWebHistory } from 'vue-router';
import Download from '../views/download/index.vue';

const routes = [
  {
    path: '/download',
    name: 'Download',
    component: Download,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
